import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { AppService, DialogService } from '../../../../../services'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'

const KEY = 'double-dialog'

@Component({
  selector: 'atyl-doublon',
  templateUrl: './doublon.component.html',
  styleUrls: ['./doublon.component.scss']
})
@Stringable({
  path: 'views/partials/layout/dialogs/doublon-dialog',
  key: KEY,
})
export class DoublonComponent extends BaseDialogComponent implements OnInit {

  @StringableValues(KEY)
  strings: any
  id: any = '';
  doublons: any = [];
  constructor(
    public dialogRef: MatDialogRef<DoublonComponent>,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialogService: DialogService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    this.id = this.data.id
    this.appService.getDoublons(this.id).subscribe((res) => {
      this.doublons = res.result
    })
  }

  Dedoublonner(elem: any) {
    //from la ligne
    //to dossier ou je suis

    this.dialogService.open(ConfirmComponent, {
      draggable: true,
    }, (res: any) => {
      if (res === 'true')
        this.appService.dedoublonner(this.id, elem.ID).subscribe((res) => {
          this.dialogRef.close(true)
        })
    })
  }

  TransformToAssmat() {
    this.dialogService.open(ConfirmComponent, {
      draggable: true,
    }, (res: any) => {
      this.appService.changeTypeTier(this.id, 'ASSMAT').subscribe((res) => {
        this.dialogRef.close(true)
      })
    })
  }
}
